module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="league-join-filter">\n	<h5>Join a Public League</h5>\n	<select class="js-filter-by" name="filter" data-type="filter">\n		<option value="" '+
((__t=( (filter === '') ? 'selected' : '' ))==null?'':_.escape(__t))+
' >Any</option>\n		<option value="head_to_head"\n			'+
((__t=( (filter === 'head_to_head') ? 'selected' : '' ))==null?'':_.escape(__t))+
' >H2H\n		</option>\n		<option value="open"\n			'+
((__t=( (filter === 'open') ? 'selected' : '' ))==null?'':_.escape(__t))+
' >Open\n		</option>\n	</select>\n</div>\n<div class="table-header">\n	<div class="table-item name">League</div>\n	<div class="table-item entries js-sort-by-team">Entries</div>\n	<div class="table-item view">Join</div>\n</div>';
}
return __p;
};
